import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSceneAnchor } from './scene/sceneRegistry';

interface ConvergenceProps {
  onPartnerClick: () => void;
}

/** "Three models. One system. Yours." — pinned center text while the beings converge below it. */
const Convergence: React.FC<ConvergenceProps> = ({ onPartnerClick }) => {
  const { t } = useTranslation();
  const anchorRef = useSceneAnchor('conv');

  return (
    <section id="lab-convergence" ref={anchorRef} className="relative z-10 h-[125vh]">
      <div className="sticky top-16 grid h-[calc(100dvh-4rem)] place-items-center px-6 pb-[170px] text-center md:px-14">
        <div className="max-w-[720px] [text-shadow:0_2px_30px_rgba(0,0,0,0.5)]">
          <div className="font-plexmono text-[11.5px] tracking-[0.18em] text-lab-frost/60">
            {t('lab.convergence.kicker')}
          </div>
          <h2 className="mt-5 text-[clamp(32px,6vw,52px)] font-semibold leading-[1.08] tracking-[-0.025em] [text-wrap:balance]">
            {t('lab.convergence.title')}
          </h2>
          <p className="mx-auto mt-5 max-w-[600px] text-[15px] leading-[1.7] text-lab-frost/70 md:text-base">
            {t('lab.convergence.desc')}
          </p>
          <button
            onClick={onPartnerClick}
            className="lab-siri mt-[30px] inline-block rounded-full bg-lab-frost px-[34px] py-[15px] text-[15px] font-semibold text-lab-ink transition-transform hover:-translate-y-0.5"
          >
            {t('lab.convergence.cta')}
          </button>
        </div>
      </div>
    </section>
  );
};

export default Convergence;
